import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faEnvelope, faLock, faUser, faClock, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import configureStore from './Redux/store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { history } from './helpers/history';
// import './css/index.css';

// Create browser history to use in the Redux store
//MOVED TO INDEX.JS in HELPERS

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

library.add(faPhone, faEnvelope, faLock, faUser, faClock, faPlus, faTimes)

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  rootElement);

registerServiceWorker();
